const SOLD_STATUS_COLOR = "#dc3545";

function isSoldStatus(statusName, statusKey) {
  const key = String(statusKey || "").trim().toLowerCase();
  const name = String(statusName || "").trim().toLowerCase();
  return key === "sold" || name === "sold";
}

export function formatVehicleStatusLabel(statusName) {
  if (!statusName) return "";
  return String(statusName).charAt(0).toUpperCase() + String(statusName).slice(1);
}

export function getVehicleStatusDisplay(vehicleStatus) {
  const statusName = vehicleStatus?.status_name || vehicleStatus?.name || "";
  const statusKey = vehicleStatus?.status_key;
  const sold = isSoldStatus(statusName, statusKey);
  return {
    label: formatVehicleStatusLabel(statusName),
    color: sold ? SOLD_STATUS_COLOR : vehicleStatus?.color,
    fontWeight: sold ? "bold" : undefined,
    isSold: sold,
  };
}
